import React from 'react';

interface IconProps {
  src: string;
  alt?: string;
  width?: number;
  height?: number;
}

const Icon: React.FC<IconProps> = ({ src, alt = 'icon', width = 24, height = 24, ...rest }) => {
  return <img src={src} alt={alt} width={width} height={height} />;
};

export default Icon;
